import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { getSpectreposSiteStatus } from "./plugin.redux";
import { openChentroShop } from "./SpectreposStatusPanel";

/**
 * Los atajos de la tarjeta de Storefront: ver la tienda en línea como la ve el
 * cliente, y entrar directo a configurarla (diseño, páginas, envíos). La
 * tienda en línea vive en la raíz del dominio de la tienda SpectrePOS; la
 * configuración se abre con SSO, sin pedir clave.
 *
 * Sólo con la tienda en Chentro lista: antes no hay a dónde ir.
 */
const StorefrontLinks = ({ ready, siteUrl, getSpectreposSiteStatus }) => {
  const { t } = useTranslation();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (ready && !siteUrl) getSpectreposSiteStatus();
  }, [ready, siteUrl]);

  if (!ready) return null;

  return (
    <Wrap>
      {siteUrl && (
        <LinkButton href={siteUrl} target="_blank" rel="noopener noreferrer">
          {t("provision.view_online_store", "View my online store")}
        </LinkButton>
      )}
      <Button
        type="button"
        secondary
        onClick={async () =>
          setFailed(!(await openChentroShop("/m/ventas/config/tienda-online")))
        }
      >
        {t("provision.configure_online_store", "Set up my online store")}
      </Button>
      {failed && (
        <Hint>
          {t(
            "provision.open_failed",
            "We couldn't open your store. Try again in a moment.",
          )}
        </Hint>
      )}
    </Wrap>
  );
};

const Wrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 10px 0;
`;

const buttonStyle = `
  display: inline-block;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 600;
  border-radius: 6px;
  border: 1px solid #0e7a4d;
  text-decoration: none;
  cursor: pointer;
`;

const LinkButton = styled.a`
  ${buttonStyle}
  color: #fff;
  background: #0e7a4d;
`;

const Button = styled.button`
  ${buttonStyle}
  color: #0e7a4d;
  background: #fff;
`;

const Hint = styled.div`
  width: 100%;
  font-size: 12px;
  color: #6b7280;
`;

export default connect(
  (state) => ({
    ready:
      state.plugin.provisionStatus === "ready" &&
      state.plugin.provisionBackend === "hbs",
    siteUrl: state.plugin.siteStatus?.site_url || null,
  }),
  { getSpectreposSiteStatus },
)(StorefrontLinks);
